import _ from "lodash";
import $ from "jquery";
import { useEffect, useState } from "react";
import {
  Button,
  Dropdown,
  DropdownItemProps,
  DropdownProps,
  Form,
  FormProps,
  Input,
  Modal,
  Search,
  Segment,
  Table,
  TextArea,
} from "semantic-ui-react";
import { dialogControl } from "../../controls/dialog-control";
import { useCurrentUser } from "../../hooks/auth-hook";
import {
  ModalControlData,
  useModalControl,
  useRequest,
} from "../../hooks/commonHooks";
import { useFormConnect, useFormData } from "../../hooks/formHooks";
import { restRequest } from "../../http";
import {
  ENUM_TYPES_EQUIPMENT_BRAND,
  ENUM_TYPES_EQUIPMENT_DEVICE,
  ENUM_TYPES_EQUIPMENT_LOCATION,
  ENUM_TYPES_EQUIPMENT_MODEL,
  ENUM_TYPES_EQUIPMENT_PART,
  ENUM_TYPES_EQUIPMENT_PROJECT_USED_FOR,
  ENUM_TYPES_EQUIPMENT_STORAGE_PLACE,
  ENUM_TYPES_EQUIPMENT_TEAM,
  ENUM_TYPES_EQUIPMENT_TYPE,
  ENUM_TYPES_ISSUE_OVERVIEW_ROOT_CAUSE,
  EnumConfig,
  PageData,
} from "../../models/common_model";
import { CommonEnumData } from "../../models/rma_tracking_model";
import { fieldError } from "../../utils";
import { Page } from "./Page";
import { JournalizationComponent } from "./JournalizationComponent";

const EnumTypeNames: { [typeId: number]: string } = {
  [ENUM_TYPES_EQUIPMENT_TYPE]: "Inventory Type",
  [ENUM_TYPES_EQUIPMENT_DEVICE]: "Inventory Product Category ",
  [ENUM_TYPES_EQUIPMENT_BRAND]: "Inventory Brand",
  [ENUM_TYPES_EQUIPMENT_STORAGE_PLACE]: "Inventory Storage Place",
  [ENUM_TYPES_EQUIPMENT_LOCATION]: "Inventory Location",
  [ENUM_TYPES_EQUIPMENT_TEAM]: "Inventory Team",
  [ENUM_TYPES_EQUIPMENT_MODEL]: "Inventory Model",
  [ENUM_TYPES_EQUIPMENT_PART]: "Inventory Part",
  [ENUM_TYPES_EQUIPMENT_PROJECT_USED_FOR]: "Inventory Project Used For",
  [ENUM_TYPES_ISSUE_OVERVIEW_ROOT_CAUSE]: "Issue Overview Root Cause"
};

const EmptyValue = '-^-empty-^-'

function CommonEnumComponent(props: { typeId: number }) {
  const { typeId } = props;
  const currentUser = useCurrentUser();
  const [searchData, setSearchField] = useFormData<any>({});
  const [models, setSearchData, loading] = useFormConnect<any, PageData<CommonEnumData>>(
    {},
    `commons/enums/${typeId}/search`
  );

  const [config] = useRequest<EnumConfig>(`commons/enums/${typeId}/config`);

  const editModalControl = useModalControl();
  const journalizationModalControl = useModalControl(0);
  const [currentEditId, setCurrentEditId] = useState<number>();
  const [reloadNumber, setReloadNumber] = useState(0);

  return (
    <>
      <Segment.Group>
        <Segment attached="top">
          <Form
            onSubmit={(e) => {
              e.stopPropagation();
              setSearchData(searchData);
            }}

            loading={loading}
          >
            <Form.Group>
              <Form.Field inline>
                <Input
                  placeholder="Name"
                  name="name"
                  value={searchData["name"] || ""}
                  onChange={setSearchField}
                />
              </Form.Field>
              <div>
                <Button icon="search" type="submit"></Button>
              </div>
            </Form.Group>
          </Form>
        </Segment>
        <Segment attached="bottom">
          <Table striped>
            <Table.Header>
              <Table.Row>
                <th>Name</th>
                <th>Name (CN)</th>
                <th>Description</th>
                <th>
                  {config &&
                    _.get(
                      currentUser.permissions,
                      config.permissions.create
                    ) && (
                      <Button
                        color="blue"
                        icon="add"
                        content={EnumTypeNames[typeId]}
                        size="mini"
                        onClick={(e) => {
                          setCurrentEditId(undefined);
                          editModalControl.setOpen(true);
                        }}
                      />
                    )}
                </th>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {models?.items.map((model) => {
                return (
                  <tr key={model.id}>
                    <td>{model.name}</td>
                    <td>{model.cn_name}</td>
                    <td>{model.description}</td>
                    <td>
                      {config &&
                        _.get(
                          currentUser.permissions,
                          config.permissions.update
                        ) && (
                          <Button
                            onClick={(e) => {
                              setCurrentEditId(model.id);
                              editModalControl.setOpen(true);
                            }}
                            color="blue"
                            icon="edit"
                            size="mini"
                          />
                        )}

                      {config &&
                        _.get(
                          currentUser.permissions,
                          config.permissions.delete
                        ) && (
                          <Button
                            onClick={(e) => {
                              dialogControl.deletionConfirm(
                                model.name,
                                (argee) => {
                                  if (argee) {
                                    return restRequest(
                                      `commons/enums/${typeId}/${model.id}`,
                                      null,
                                      "delete"
                                    ).then(() => {
                                      setSearchData((searchData: any) => ({
                                        ...searchData,
                                        refresh: (searchData.refresh || 1) + 1,
                                      }));
                                    }).catch(() => 1);
                                  }
                                  return Promise.resolve();
                                }
                              );
                            }}
                            color="red"
                            icon="delete"
                            size="mini"
                          />
                        )}

                      <Button
                        title="Journalization"
                        onClick={(e) => {
                          e.preventDefault();
                          journalizationModalControl.data = model.id;
                          journalizationModalControl.setOpen(true);
                        }}
                        icon="history"
                        size="mini"
                      ></Button>
                    </td>
                  </tr>
                );
              })}
            </Table.Body>
          </Table>
          <Page data={models} updatePage={setSearchData}></Page>
        </Segment>
      </Segment.Group>

      <CommonEnumEditor
        typeId={typeId}
        id={currentEditId}
        modelControl={editModalControl}
        onFinish={(result) => {
          setSearchData((searchData: any) => ({
            ...searchData,
            refresh: (searchData.refresh || 1) + 1,
          }));
          editModalControl.setOpen(false);
          setReloadNumber((n) => n + 1);
        }}
      ></CommonEnumEditor>

      {journalizationModalControl.data > 0 && (
        <Journalization modalControl={journalizationModalControl} />
      )}
    </>
  );
}

function CommonEnumEditor(props: {
  typeId: number;
  id?: number;
  modelControl: ModalControlData;
  onFinish: (data: CommonEnumData) => void;
}) {
  const { typeId, id, modelControl, onFinish } = props;
  const isCreate = !id;

  const [data, setField, setData] = useFormData<CommonEnumData>({} as any);
  const [invalidError, setInvalidError] = useState<any>({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setData({ admin: false } as any);
    setInvalidError({});
    if (id) {
      setLoading(true);
      restRequest<CommonEnumData>(`commons/enums/${typeId}/${id}`)
        .then(setData)
        .finally(() => setLoading(false));
    } else {
      setData((d) => ({ ...d }));
    }
  }, [id]);

  const onSubmit = (
    event: React.FormEvent<HTMLFormElement>,
    formProps: FormProps
  ) => {
    event.stopPropagation();
    event.preventDefault();

    setLoading(true);

    restRequest<CommonEnumData>(
      `commons/enums/${typeId}${isCreate ? "" : "/" + id}`,
      data,
      isCreate ? "post" : "put"
    )
      .then(
        (result) => {
          props.onFinish(result);
          setInvalidError({});
        },
        (resp) => {
          if (resp.status === 2) {
            setInvalidError(resp.data);
          }
        }
      )
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Modal {...props.modelControl.props} size="large">
        <Modal.Header>
          {isCreate ? "Create" : "Update"} {EnumTypeNames[typeId]}{" "}
        </Modal.Header>
        <Modal.Content>
          <Form onSubmit={onSubmit} loading={loading}>
            <Form.Group widths="equal">
              <Form.Input
                label="Name"
                name="name"
                value={data["name"] || ""}
                onChange={setField}
                required
                error={fieldError("name", invalidError)}
              ></Form.Input>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                label="Name (CN)"
                name="cn_name"
                value={data["cn_name"] || ""}
                onChange={setField}
                error={fieldError("cn_name", invalidError)}
              ></Form.Input>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                label="Description"
                error={fieldError("description", invalidError)}
              >
                <TextArea
                  name="description"
                  value={data.description || ""}
                  onChange={setField}
                />
              </Form.Input>
            </Form.Group>
            <div>
              <Button primary>Submit</Button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Button as="a" onClick={(e) => props.modelControl.setOpen(false)}>
                Cancel
              </Button>
            </div>
          </Form>
        </Modal.Content>
      </Modal>
    </>
  );
}

export function CommonEnumSelector(props: {
  typeId: number;
  label: string;
  name: string;
  value: string | string[];
  onChange: (
    event: React.SyntheticEvent<HTMLElement, Event>,
    data: DropdownProps
  ) => void;
  required?: boolean;
  multiple?: boolean;
  error?: any;
}) {
  const { typeId, label, name, value, onChange, required, multiple, error } = props;
  const modalControl = useModalControl();
  const [refresh, setRefresh] = useState(0);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<DropdownItemProps[]>([]);

  useEffect(() => {
    setLoading(true);
    restRequest<DropdownItemProps[]>(
      `commons/enums/${typeId}/search_for_selection?refresh=${refresh}`
    )
      .then((options) => {
        setOptions([
          ...(!required ? [{ key: "", text: "", value: "" }] : []),
          ...options,
        ]);
      })
      .finally(() => setLoading(false));
  }, [typeId, refresh]);

  return (
    <>
      <Form.Input
        label={
          <>
            <label style={{ display: "inline-block", marginRight: "1rem" }}>
              {label}
            </label>{" "}
            <Button
              onClick={(e) => modalControl.setOpen(true)}
              compact
              color="blue"
              icon="edit outline"
              size="mini"
              as="a"
            ></Button>
          </>
        }
        required={required || false}
        error={error}
      >
        <Dropdown
          name={name}
          value={value}
          onChange={onChange}
          options={options}
          loading={loading}
          search
          selection
          fluid
          multiple={multiple}
        ></Dropdown>
      </Form.Input>

      <Modal
        open={modalControl.props.open}
        onClose={() => {
          modalControl.props.onClose();
          setRefresh((n) => n + 1);

          $(window).trigger(`refresh_enum_data_${typeId}`);
        }}
        size="large"
        closeIcon="close"
      >
        <Modal.Header> {EnumTypeNames[typeId]} </Modal.Header>
        <Modal.Content>
          <CommonEnumComponent typeId={typeId} />
        </Modal.Content>
        <Modal.Actions>
          <Button
            as="a"
            className="cancel"
            onClick={(e) => {
              e.preventDefault();
              modalControl.props.onClose();
              setRefresh((n) => n + 1);

              $(window).trigger(`refresh_enum_data_${typeId}`);
            }}
          >
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}

export function EnumSearchDropdown(props: {
  typeId: number;
  label?: string;
  placeholder?: string;
  name: string;
  value: string;
  onChange: (
    event: React.SyntheticEvent<HTMLElement, Event>,
    data: DropdownProps
  ) => void;
}) {
  const { typeId, label, placeholder, name, value, onChange } = props;
  const [refresh, setRefresh] = useState(0);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<DropdownItemProps[]>([
    { key: "all", text: "All", value: EmptyValue, isAdded: true },
  ]);

  useEffect(() => {
    setLoading(true);
    restRequest<DropdownItemProps[]>(
      `commons/enums/${typeId}/search_for_selection?refresh=${refresh}`
    )
      .then((options) => {
        setOptions((originalOptions) => {
          return [...originalOptions.filter((o) => o.isAdded), ...options];
        });
      })
      .finally(() => setLoading(false));
  }, [typeId, refresh]);

  useEffect(() => {
    const onRefresh = () => {
      setRefresh((n) => n + 1);
    };
    $(window).on(`refresh_enum_data_${typeId}`, onRefresh);

    return () => {
      $(window).off(`refresh_enum_data_${typeId}`, onRefresh);
    };
  }, [typeId]);

  useEffect(() => {
    if (placeholder) {
      setOptions((os) => [
        { key: "all", text: `${placeholder}: All`, value: EmptyValue, isAdded: true },
        os.slice(1),
      ]);
    } else {
      setOptions((os) => [
        { key: "all", text: "All", value: EmptyValue, isAdded: true },
        os.slice(1),
      ]);
    }
  }, [placeholder]);

  return (
    <Dropdown
      name={name}
      value={value || EmptyValue}
      placeholder={placeholder}
      onChange={(e, d) => {
        onChange(e, { ...d, value: d.value === EmptyValue ? '' : d.value })
      }}
      options={options}
      loading={loading}
      search
      selection
      allowAdditions
      onAddItem={(e, d) => {
        setOptions((os) => [
          os[0],
          {
            key: d.value,
            text: d.value as string,
            value: d.value as string,
            isAdded: true,
          },
          ...os.slice(1),
        ]);
      }}
      className="mini"
    ></Dropdown>
  );
}


function Journalization(props: { modalControl: ModalControlData<number> }) {
  return (
    <Modal {...props.modalControl.props}>
      <Modal.Header>Journalization</Modal.Header>
      <Modal.Content>
        <JournalizationComponent
          containerId={props.modalControl.data}
          containerType={6}
          detailFields={[
            { key: "name", name: "Name" },
            { key: "description", name: "Description" },
            { key: "cn_name", name: "Name(Chinese)" },
          ]}
        />
      </Modal.Content>
    </Modal>
  );
}